import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { blurQuantity, setQuantity } from '../../../redux/giveaway-landing/giveaway-landing.actions';
import { giveawayLandingProductSizesSettingsSelector, hasGiveawayLandingProductSizesSelector, multipleProductsQuantitiesStatusSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { ERROR_TYPES } from '../multiple-products-selection-error/multiple-products-selection-error';
import { MultipleProductSelectionForColorComponent } from './multiple-product-selection-for-color';
const hasSizesSelector = createSelector(hasGiveawayLandingProductSizesSelector, giveawayLandingProductSizesSettingsSelector, (hasSizeToChoice, sizeSettings) => {
  return sizeSettings && hasSizeToChoice;
});
const selectedQuantitiesFromPropsSelector = (state, props) => {
  return props.selectedQuantitiesInfo;
};
const errorsPropsSelector = (state, props) => {
  return props.errors;
};
const colorVariantIdPropsSelector = (state, props) => {
  return props.colorVariantId;
};
const parentIdPropsSelector = (state, props) => {
  return props.parentId;
};
const errorSelector = createSelector(errorsPropsSelector, colorVariantIdPropsSelector, parentIdPropsSelector, multipleProductsQuantitiesStatusSelector, hasSizesSelector, (multipleProductErrors, colorVariantId, parentId, touchedQuantitiesMap, hasSize) => {
  const errors = multipleProductErrors || [];
  const key = colorVariantId || parentId || '';
  const isTouched = touchedQuantitiesMap[key];
  const zeroError = errors.find(({
    type
  }) => type === ERROR_TYPES.ZERO_QUANTITY_SELECTED);
  if (zeroError && isTouched) {
    return zeroError;
  }
  const moreThanInStock = errors.find(({
    type
  }) => type === ERROR_TYPES.MORE_THAN_AVAILABLE_FOR_VARIANT);
  const moreThanCapError = errors.find(({
    type
  }) => type === ERROR_TYPES.MORE_THAN_CAP);
  if (!hasSize) {
    if (moreThanInStock && !moreThanCapError) {
      return moreThanInStock;
    }
    if (!moreThanInStock && moreThanCapError) {
      return moreThanCapError;
    }
    if (moreThanInStock && moreThanCapError) {
      const {
        totalAmountForColorVariant,
        cap
      } = moreThanCapError.data;
      const {
        available
      } = moreThanInStock.data;
      if (totalAmountForColorVariant > cap && available > cap) {
        return moreThanCapError;
      }
      return moreThanInStock;
    }
  }
  if (moreThanCapError) {
    return moreThanCapError;
  }
});
const quantitiesDataSelector = createSelector(selectedQuantitiesFromPropsSelector, errorsPropsSelector, (selectedQuantitiesInfo, errors) => {
  const isBeyondCapError = errors === null || errors === void 0 ? void 0 : errors.some(error => error.type === ERROR_TYPES.MORE_THAN_CAP);
  return selectedQuantitiesInfo.reduce((acc, selectedQuantityObj, index) => {
    if (!isBeyondCapError) {
      acc.availableQuantities.push(selectedQuantityObj.availableQuantity);
    }
    acc.selectedQuantities.push(selectedQuantityObj.amount);
    if (selectedQuantityObj.availableQuantity === 0) {
      acc.outOfStockSizes.add(index);
    }
    return acc;
  }, {
    availableQuantities: [],
    selectedQuantities: [],
    outOfStockSizes: new Set()
  });
});
const mapStateToProps = createStructuredSelector({
  error: errorSelector,
  hasSizes: hasSizesSelector,
  quantitiesData: quantitiesDataSelector,
  sizeSettings: giveawayLandingProductSizesSettingsSelector,
  touchedQuantitiesMap: multipleProductsQuantitiesStatusSelector
});
const mapDispatchToProps = dispatch => bindActionCreators({
  setQuantity,
  blurQuantity
}, dispatch);
export const MultipleProductSelectionForColor = connect(mapStateToProps, mapDispatchToProps)(MultipleProductSelectionForColorComponent);